export var ServiceLocationType;
(function (ServiceLocationType) {
    ServiceLocationType["CLIENT_PLACE"] = "CLIENT_PLACE";
    ServiceLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    ServiceLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
})(ServiceLocationType || (ServiceLocationType = {}));
export var ReservedLocationIds;
(function (ReservedLocationIds) {
    ReservedLocationIds["OTHER_LOCATIONS"] = "OTHER_LOCATIONS";
    ReservedLocationIds["UNSPECIFIED_LOCATION"] = "UNSPECIFIED_LOCATION";
})(ReservedLocationIds || (ReservedLocationIds = {}));
//# sourceMappingURL=service-location.dto.js.map